import React from 'react'
import { CustomLink } from '@/components/atoms/CustomLink/CustomLink'
import { Accordion } from '@/components/molecules/Accordion/Accordion'
import { ArticleSideBarProps } from './types'

export function ArticleSideBar({ sidebar_accordion }: ArticleSideBarProps) {
  return sidebar_accordion?.items?.length > 0 ? (
    <section className="h-full">
      <ul className="list-none">
        {sidebar_accordion.items?.map((item) => <Accordion key={item._uid} title={item.title} links={item.links} />)}
      </ul>
      {sidebar_accordion.additional_links?.length > 0 ? (
        <div className="mt-20 border-t-1 border-grey-100 pt-20 w-11/12">
          {sidebar_accordion.additional_links.map((additionalLink) => (
            <p className="mb-24 font-mulish">
              <CustomLink className="text-primary-600 text-bodyL" {...additionalLink} key={additionalLink._uid}>
                {additionalLink.text}
              </CustomLink>
            </p>
          ))}
        </div>
      ) : null}
    </section>
  ) : null
}
